import { ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';
import { Clapperboard, Video } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import type { VideoOperation, VideoOperationConfig } from '../types';

const OPERATION_ICONS: Record<VideoOperation, typeof Video> = {
  text_to_video: Video,
  image_to_video: Clapperboard,
};

interface OperationTabsProps {
  operations: VideoOperationConfig[];
  value: VideoOperation;
  onChange: (operation: VideoOperation) => void;
}

export const OperationTabs: React.FC<OperationTabsProps> = ({ operations, value, onChange }) => {
  const { t } = useTranslation();

  return (
    <ToggleButtonGroup
      exclusive
      fullWidth
      size="small"
      value={value}
      onChange={(_event, next: VideoOperation | null) => next && onChange(next)}
      aria-label={t('services.generateVideo.operationLabel')}
    >
      {operations.map((operation) => {
        const Icon = OPERATION_ICONS[operation.capabilityCode];
        const button = (
          <ToggleButton
            key={operation.capabilityCode}
            value={operation.capabilityCode}
            disabled={!operation.enabled}
            className="gap-2 normal-case"
          >
            <Icon size={16} />
            {t(operation.labelKey)}
          </ToggleButton>
        );
        return operation.enabled ? (
          button
        ) : (
          <Tooltip
            key={operation.capabilityCode}
            title={t(`services.generateVideo.unavailable.${operation.reason ?? 'not_in_package'}`)}
          >
            <span className="flex-1">{button}</span>
          </Tooltip>
        );
      })}
    </ToggleButtonGroup>
  );
};
